import React from "react";
import { MdOutlineCancel } from "react-icons/md";

const CustomOption = (props) => {
  const { data, innerRef, innerProps, selectProps } = props;

  const handleDeleteOption = (e) => {
    e.stopPropagation(); // Prevents the select action when clicking the delete icon
    selectProps.onDeleteOption(data);
  };

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className="custom-option d-flex justify-content-between align-items-center p-2"
    >
      <span>{data.label}</span>
      <MdOutlineCancel
        onClick={handleDeleteOption}
        className="delete-option-button"
        size={15}
      />
    </div>
  );
};

export default CustomOption;
